import { defineStore } from 'pinia';
import i18n from '@/common/i18n';
import AgreementRepository from '@/repositories/agreementRepository';
import apiResponseErrorService from '@/commonProject/service/apiResponseErrorService';
import cognitoRepository from '@/repositories/common/cognitoRepository';
import utils from '@/commonProject/helpers/utils';

export const useAgreementDetailStore = defineStore({
    id: 'agreementDetail',
    state: () => ({
        RegulationPk: '',
        RegulationHistPk: '',
        RegulationNm: '',
        AgreementDt: '',
        RegulationDt: '',
        RegulationContent: '',
    }),
    getters: {},
    actions: {
        /**
         * ユーザー同意規定取得API
         * @param {String} API_URL
         * @param {*} requestBody
         * @returns response
         */
        async getUserAgreementAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const agreementRepository = new AgreementRepository();

            try {
                const response = await agreementRepository.getUserAgreementApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.RegulationPk = response.data.RegulationPk;
                this.RegulationHistPk = response.data.RegulationHistPk;
                this.RegulationNm = response.data.RegulationNm;
                this.AgreementDt = utils.isNullEmpty(response.data.AgreementDt) ? '' : response.data.AgreementDt.split(' ')[0];
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        /**
         * 規定詳細取得API
         * @param {String} API_URL
         * @param {*} requestBody
         * @returns response
         */
        async getAgreementDetailAction(API_URL, requestBody) {
            //const cognitoRepository = new CognitoRepository();
            const cognitoIdTokenKeyName = await cognitoRepository.getTokenKey();
            const idToken = localStorage.getItem(cognitoIdTokenKeyName);

            const agreementRepository = new AgreementRepository();

            try {
                const response = await agreementRepository.getAgreementDetailApi(API_URL, requestBody, idToken);
                const specialApiError = apiResponseErrorService.isStatus200HasError(response);
                if (specialApiError.status) {
                    return { success: false, errorMessage: specialApiError.message, redirect: false, redirectUrl: '' };
                }
                this.RegulationNm = response.data.RegulationNm;
                this.RegulationHistPk = response.data.RegulationHistPk;
                this.RegulationDt = response.data.RegulationDt.split(' ')[0];
                this.RegulationContent = response.data.RegulationContent;
                return { success: true };
            } catch (e) {
                return {
                    success: false,
                    errorMessage: apiResponseErrorService.errorMessage(e.response, 'get', i18n.global),
                    redirect: apiResponseErrorService.isLogoutToRedirect(e.response),
                    redirectUrl: apiResponseErrorService.logoutToRedirectUrl(e.response),
                };
            }
        },
        reset() {
            this.RegulationPk = '';
            this.RegulationHistPk = '';
            this.RegulationNm = '';
            this.AgreementDt = '';
            this.RegulationDt = '';
            this.RegulationContent = '';
        },
    },
    persist: {
        storage: sessionStorage,
    },
});
